import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { MailingRecord } from '../models/MailingRecord';
import { SaveMailingRecord } from '../models/SaveMailingRecord';

@Injectable({ providedIn: 'root' })

export class MailingRecordService { 
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/mailingRecords';
  }
    
  getAll(id: number): Observable<Array<MailingRecord>> { 
    return this.http.get<Array<MailingRecord>>(this._ENDPOINT + "/" + id);
  }

  getById(id: any): Observable<MailingRecord> {
    const url = this._ENDPOINT+'/?id='+id;
    return this.http.get<MailingRecord>(url);
  }

  /** POST: add a new mailingRecord to the server */
  add(mailingRecord: MailingRecord): Observable<MailingRecord> {
    return this.http.post<MailingRecord>(this._ENDPOINT, mailingRecord, this.httpOptions).pipe(
      tap((newMailingRecord: MailingRecord) => this.log('added mailingRecord w/ id=${newMailingRecord.id}')),
      catchError(this.handleError<MailingRecord>('add'))
    );
  } 

  /** POST: add a new mailingRecord to the server */
  addBulk(id: number, mailingRecords: SaveMailingRecord[]): Observable<SaveMailingRecord> { 
    return this.http.post<SaveMailingRecord>(this._ENDPOINT + "/" + id, mailingRecords, this.httpOptions).pipe(
     // tap((newMailingRecord: MailingRecord) => this.log('added mailingRecord w/ id=${newMailingRecord.id}')),
      catchError(this.handleError<SaveMailingRecord>('add'))
    );
  }

  /** DELETE: delete the mailingRecord from the server */
  delete(mailingRecord: MailingRecord | number): Observable<MailingRecord> {
    const id = typeof mailingRecord === 'number' ? mailingRecord : mailingRecord.id;
    const url = this._ENDPOINT + '/' + id;
     
    return this.http.delete<MailingRecord>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted mailingRecord id=${id}')),
      catchError(this.handleError<MailingRecord>('delete'))
    );
  }

  /** PUT: update the mailingRecord on the server */
  update(id: number, mailingRecord: MailingRecord): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id , mailingRecord , this.httpOptions).pipe(
      tap(_ => this.log('updated mailingRecord id=${mailingRecord.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a MailingRecordService message with the MessageService */
  private log(message: string) {
    this.messageService.add('MailingRecordService: ${message}');
  }
}
